import { useState } from "react";
import { HashRouter as Router, Route, Routes, NavLink} from "react-router-dom";
import {
  CContainer,
  CSidebar,
  CSidebarNav,
  CSidebarBrand,
  CNavItem,
  CNavLink,
  CSidebarFooter,
  CRow,
  CCol,
} from "@coreui/react";
import CIcon from '@coreui/icons-react';
import { cilList, cilPlus} from '@coreui/icons';

// Import components
import Header from "./components/Header";
import SkillCreator from "./components/SkillCreator";
import SkillList from "./components/SkillList";
import SkillDetail from "./components/SkillDetail";
import SkillPublisher from "./components/SkillPublisher";
import Login from "./components/Login";
import ProtectedRoute from "./components/ProtectedRoute";

function App() {
  const [refreshKey, setRefreshKey] = useState(0);
  const [sidebarShow, setSidebarShow] = useState(true);

  // Handler to refresh the skills list after creating a new skill
  const handleSkillCreated = () => {
    setRefreshKey(prevKey => prevKey + 1);
  };

 
  // Dashboard layout component
  const DashboardLayout = () => {

    return (
      <div className="App d-flex">
        {/* Sidebar */}
        <CSidebar
          position="fixed"
          visible={sidebarShow}
          onVisibleChange={(visible) => {
            setSidebarShow(visible);
          }}
          className="sidebar-dark"
          style={{ height: '100vh', zIndex: 1030 }}
        >
          <CSidebarBrand className="d-md-flex">
            <h3 className="mt-2">Alexa Skill Portal</h3>
          </CSidebarBrand>
          <CSidebarNav>
            <CNavItem>
              <CNavLink component={NavLink} to="/create" className={({ isActive }) => isActive ? "active" : ""}>
                <CIcon icon={cilPlus} className="nav-icon" />
                Create New Alexa Skill
              </CNavLink>
            </CNavItem>
            <CNavItem>
              <CNavLink component={NavLink} to="/skills" className={({ isActive }) => isActive ? "active" : ""}>
                <CIcon icon={cilList} className="nav-icon" />
                Alexa Skills List
              </CNavLink>
            </CNavItem>
          </CSidebarNav>

          {/* Footer */}
          <CSidebarFooter className="p-3">
            <div className="text-center">
              <span className="text-white">&copy; {new Date().getFullYear()} Sleep Sounds</span>
            </div>
          </CSidebarFooter>
        </CSidebar>

        {/* Main content */}
        <div className="d-flex flex-column flex-grow-1 min-vh-100" style={{ marginLeft: sidebarShow ? '256px' : '0', transition: 'margin-left 0.3s ease' }}>
          {/* Header */}
          <Header sidebarShow={sidebarShow} setSidebarShow={setSidebarShow} />

          {/* Body */}
          <div className="body flex-grow-1 px-3 pt-4">
            <CContainer fluid>
              {/* Main content area */}
              <Routes>
                <Route
                  path="/create"
                  element={
                    <CRow>
                      <CCol xs={12}>
                        <SkillCreator onSkillCreated={handleSkillCreated} />
                      </CCol>
                    </CRow>
                  }
                />
                <Route
                  path="/skills"
                  element={
                    <CRow>
                      <CCol xs={12}>
                        <SkillList key={refreshKey} />
                      </CCol>
                    </CRow>
                  }
                />
                <Route
                  path="/skill-detail"
                  element={
                    <CRow>
                      <CCol xs={12}>
                        <SkillDetail />
                      </CCol>
                    </CRow>
                  }
                />
                <Route
                  path="/publish"
                  element={
                    <CRow>
                      <CCol xs={12}>
                        <SkillPublisher />
                      </CCol>
                    </CRow>
                  }
                />
              </Routes>
            </CContainer>
          </div>
        </div>
      </div>
    );
  };

  return (
    <Router>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route 
          path="/*" 
          element={
            <ProtectedRoute>
              <DashboardLayout />
            </ProtectedRoute>
          } 
        />
      </Routes>
    </Router>
  );
}

export default App;